var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { staticClass: "table" },
    [
      _c(
        "el-row",
        { staticClass: "row-bg" },
        [
          _c("el-date-picker", {
            staticClass: "mb-10 mr-10",
            attrs: {
              type: "year",
              "value-format": "yyyy",
              placeholder: "选择年份",
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.dateTime,
              callback: function ($$v) {
                _vm.dateTime = $$v
              },
              expression: "dateTime",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "tb-button",
              attrs: { type: "primary" },
              on: { click: _vm.search },
            },
            [_vm._v("查 询")]
          ),
          _c(
            "el-button",
            {
              staticClass: "tb-button",
              attrs: { type: "info" },
              on: { click: _vm.snapshot },
            },
            [_vm._v("生成快照")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "tb-list",
          attrs: {
            data: _vm.dataList,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "起止时间", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.min.substring(0, 10))),
                    ]),
                    _vm._v(" ~ "),
                    _c("span", [
                      _vm._v(_vm._s(scope.row.max.substring(0, 10))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", prop: "createTime" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.preview(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看报表")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.update(scope.row)
                          },
                        },
                      },
                      [_vm._v("更新快照薪酬")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pagination.currentPage,
          "page-sizes": _vm.pagination.pageSizes,
          "page-size": _vm.pagination.pageSize,
          layout: _vm.pagination.layout,
          total: _vm.pagination.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("create-snapshot", {
        attrs: { show: _vm.snapshotDialog },
        on: {
          close: function ($event) {
            _vm.snapshotDialog = false
          },
          updateView: _vm.getListSnapshot,
        },
      }),
      _c("sele-filtration", {
        attrs: {
          show: _vm.filtrationDialog,
          minTime: _vm.minTime,
          maxTime: _vm.maxTime,
          ssid: _vm.ssid,
        },
        on: {
          close: function ($event) {
            _vm.filtrationDialog = false
          },
        },
      }),
      _c("history-report", {
        attrs: {
          show: _vm.reportDialog,
          reportData: _vm.reportData,
          minTime: _vm.minTime,
          maxTime: _vm.maxTime,
          ssid: _vm.ssid,
          total: _vm.total,
        },
        on: {
          close: function ($event) {
            _vm.reportDialog = false
            _vm.reportData = []
          },
          historyParams: _vm.historyParams,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }